<script setup lang="ts">
import TokensPageSummary from '~/components/@pages/tokens/[address]/TokensPageSummary.vue'
import TokensPageTabs from '~/components/@pages/tokens/[address]/TokensPageTabs.vue'
import BackButton from '~/components/button/BackButton.vue'
import { getTokenSeoName } from '~/constants/token.constants'

const route = useRoute()

const address = route.params.address as string
const tokenName = getTokenSeoName(address)
const displayName = tokenName ?? `${address.slice(0, 8)}...${address.slice(-6)}`

useSeoMeta(getMeta(`Token ${displayName}`, `Explore details of Token ${displayName} on MapleStory Universe Explorer`))
</script>

<template>
  <div class="relative">
    <BackButton :url="routes.getTokensPage()" />
    <TokensPageSummary class="mt-4" />
    <hr class="my-4 bg-primary opacity-20">
    <TokensPageTabs class="relative z-10 mb-4" />
    <div class="flex flex-col gap-y-2">
      <NuxtPage />
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
